import { ReactNode } from 'react';

export default function FormItem(props: {
  title: string;
  subtitle?: string;
  className?: string;
  children?: ReactNode;
  obligatory?: boolean;
}) {
  return (
    <div className={props.className}>
      <label className="font-normail block flex items-center gap-1.5 text-sm leading-6 text-gray-900">
        <span>
          {props.title}
          {props.obligatory && <span className="text-red-500"> *</span>}
        </span>
        <span className="text-xs font-normal italic text-gray-500">{props.subtitle} </span>
      </label>
      <div className="mt-2">{props.children}</div>
    </div>
  );
}
